import React, { useState, useRef, useEffect } from "react"

import ContentfulSignupForm from "components/page-components/sign-up-form"
import MultiListSignupForm from "components/multi-list-signup-form"

const ContentfulMultiListSignupForm = ({ className, component, elRef }) => {
  const { preheading, preheadingFont, heading, headingFont, bodyText, baseForm, signupForms } =
    component

  const preheadingProps = {
    [preheadingFont === "mbg logo font" ? "monolineText" : "text"]: preheading,
    useLineOnMobile: true,
  }

  const headingProps = {
    [headingFont === "mbg logo font" ? "monolineText" : "text"]:
      heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1"),
  }

  const signupRef = useRef(null)

  // first newsletter selected by default
  const [selectedItems, setSelectedItems] = useState([
    true,
    ...new Array(signupForms.length - 1).fill(false),
  ])
  const handleItemClick = (idx) => {
    const newSelectedItems = [...selectedItems]
    newSelectedItems[idx] = !newSelectedItems[idx]
    setSelectedItems(newSelectedItems)
  }

  const [selectedMultiListSignupForms, setSelectedMultiListSignupForms] = useState([])

  useEffect(() => {
    setSelectedMultiListSignupForms(
      signupForms
        .filter((form, idx) => selectedItems[idx])
        .map((form) => ({ list: form.emailList, source: form.emailSource })),
    )
  }, [signupForms, selectedItems])

  return (
    <MultiListSignupForm
      className={className}
      elRef={elRef}
      preheading={preheadingProps}
      heading={headingProps}
      subheading={bodyText && bodyText.childMarkdownRemark.html}
      baseForm={
        <ContentfulSignupForm
          elRef={signupRef}
          component={baseForm}
          multiListSignupForms={selectedMultiListSignupForms}
          nested
        />
      }
      signupForms={signupForms}
      selectedItems={selectedItems}
      onItemClick={handleItemClick}
    />
  )
}

export default ContentfulMultiListSignupForm
